<template lang="pug">
  div.submit
    van-form(@submit="onSubmit")
        van-field(class="submit_select", :value="type", :placeholder="this.$t('selectQuestionType')", readonly, @click="typeShow = true", :rules="[{required: true, message: this.$t('selectQuestionType')}]")
        //- van-field(v-model="game", placeholder="请选择游戏产品", disabled)
        van-field(v-model="showServerName", v-if="appid !== '1017'" :placeholder="this.$t('inputService')", :rules="[{required: (appid == '1017' ? false : true), message: this.$t('inputService')}]")
        van-field(v-model="showRoleName", :placeholder="this.$t('inputRoll')", :rules="[{required: true, message: this.$t('inputRoll')}]")
        van-field(v-model="phone", type="tel", :placeholder="this.$t('inputTel')", :rules="[{ pattern: /^$|^\\+?\\d+(-)?\\d+$/, message: this.$t('patternTelErr')}]")
        van-field(v-model="email", :placeholder="this.$t('inputEmail')", :rules="[{ pattern: /^$|^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: this.$t('emailPatternErr')}]")
        van-field(v-model="content", rows="3", autosize, type="textarea", maxlength="500", :placeholder="this.$t('inputMsg')", show-word-limit, :rules="[{required: true, message: this.$t('inputMsg')}]")
        van-field(name="uploader")
            template(#input)
                van-uploader(v-model="uploader", accept="image/*, video/*", :before-read="beforeRead")
        van-button(type="danger", class="submit_btn", round, :disabled='isDisabled') {{this.$t('submit')}}
        van-popup(v-model="typeShow", position="bottom")
            van-picker(show-toolbar, :columns="columns", @confirm="pickerConfirm", @cancel="typeShow = false", :confirm-button-text="sure", :cancel-button-text="back")
    van-loading(v-if="showLoad===true", color="#E60012", vertical) {{$t('uploading')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Submit',
  data(){
    return{
        typeShow: false,
        type: '',
        typeId: '',
        game: '',
        showServerName: '',
        showRoleName: '',
        phone: '',
        email: '',
        content: '',
        uploader: [],
        updata: [],
        columns: [],
        isDisabled: false,
        showLoad: false
    }
  },
  created(){
  },
  methods:{
    ...mapActions('faq', ['submitQu', 'getCategoryList']),
    beforeRead(val){
      return new Promise((resolve, reject) => {
        if(this.uploader.length > 0){
          this.uploader.map(v => {
            if(val.name === v.file.name){
              reject()
            }
          })
          resolve(val)
        } else {
          resolve(val)
        }
      })
    },
    toCanvas(item){
      this.updata = [];
      return new Promise((resolve) => {
        if(item.file.type.includes('image')){
          const img = new Image()
          img.src = item.content
          img.onload = () => {
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            const originWidth = img.width;
            const originHeight = img.height;
            const maxWidth = 1600;
            const maxHeight = 1200;
            let targetWidth = originWidth;
            let targetHeight = originHeight;
            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                // 更宽，按照宽度限定尺寸
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
              } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
              }
            };
            // canvas对图片进行缩放
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            // 清除画布
            context.clearRect(0, 0, targetWidth, targetHeight);
            // 图片压缩
            context.drawImage(img, 0, 0, targetWidth, targetHeight);
            const newImg = this.dataURLtoFileFun(canvas.toDataURL(item.file.type, 0.9), item.file.name, item.file.type)
            resolve(newImg)
            // canvas.toBlob(
            //   blob => {// blob {size:31784, type: "image/jpeg"}
            //     const newImg = new window.File([blob], item.file.name, {type: item.file.type})
            //     resolve(newImg)
            //     // setCanvasToBlob(blob);
            //   },
            //   item.file.type,
            //   0.7,
            // );
            // this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
            // const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            // const code = jsQR(imageData.data, imageData.width, imageData.height);
          }
        }
      })
        
    },
    onSubmit(){
      if(this.showLoad){
        return false
      }
      this.content = this.content.replaceAll('\n','</br>')
      let items = this.uploader.values();
      // if(items)
      if(this.uploader.length === 0){
        this.showLoad = true
        this.submitQu({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          appId: this.appid,
          sessionName: this.uname,
          email: this.email,
          phone: this.phone,
          type: this.typeId,
          content: this.content,
          serverName: this.showServerName || '',
          roleName: this.showRoleName,
          faqId: this.$route.query.id || '',
          channelId: this.channelId,
          clientPlat: this.clientPlat,
          sdkVersion: this.sdkVersion,
          phoneModel: this.phoneModel,
          apkVersion: this.apkVersion,
          roleId: this.roleId,
          serverId: this.serverId,
          areaId: this.areaId,
          uniqueId: this.uniqueId
        })
      } else {
        for(let item of items){
          if(item.file.type.includes('video')){
            let items = this.uploader.values();
            console.log(this.uploader);
            this.updata = [];
            for(let item of items){
                this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
            }
            let count = 0
            this.updata.map(val => {
              count += val.size
            })
            if(count > 104857600){
              Toast({
                message: this.$t('limit10M'),
                type: "fail"
              })
            } else {
              if(!this.isDisabled){
                this.showLoad = true
                this.submitQu({
                    uid: this.uid,
                    deviceId: this.deviceId,
                    accessToken: this.token,
                    appId: this.appid,
                    sessionName: this.uname,
                    email: this.email,
                    phone: this.phone,
                    type: this.typeId,
                    phoneModel: this.phoneModel,
                    content: this.content,
                    serverName: this.showServerName || '',
                    roleName: this.showRoleName,
                    files: this.updata,
                    faqId: this.$route.query.id || '',
                    channelId: this.channelId,
                    clientPlat: this.clientPlat,
                    sdkVersion: this.sdkVersion,
                    apkVersion: this.apkVersion,
                    roleId: this.roleId,
                    serverId: this.serverId,
                    areaId: this.areaId,
                    uniqueId: this.uniqueId
                })
              }
            }
          } else {
            this.toCanvas(item).then(val => {
              this.updata.push(val)
              if(this.updata.length === this.uploader.length){
                let count = 0
                this.updata.map(val => {
                  count += val.size
                })
                if(count > 104857600){
                  Toast({
                    message: this.$t('limit10M'),
                    type: "fail"
                  })
                } else {
                  if(!this.isDisabled){
                    this.showLoad = true
                    this.submitQu({
                        uid: this.uid,
                        deviceId: this.deviceId,
                        accessToken: this.token,
                        appId: this.appid,
                        sessionName: this.uname,
                        email: this.email,
                        phone: this.phone,
                        type: this.typeId,
                        content: this.content,
                        serverName: this.showServerName || '',
                        roleName: this.showRoleName,
                        files: this.updata,
                        faqId: this.$route.query.id || '',
                        channelId: this.channelId,
                        clientPlat: this.clientPlat,
                        sdkVersion: this.sdkVersion,
                        apkVersion: this.apkVersion,
                        roleId: this.roleId,
                        serverId: this.serverId,
                        phoneModel: this.phoneModel,
                        areaId: this.areaId,
                        uniqueId: this.uniqueId
                    })
                    this.isDisabled = true
                  }
                }
              }
            })
          }
        }
      }
    },

    dataURLtoFileFun (dataurl, filename, type) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: type });
    },

    pickerConfirm(v){
        this.type = v;
        this.categoryList.faqCategoryList.map(val => {
            if(val.title === this.type){
                this.typeId = val.id
            }
        });
        console.log(this.typeId)
        this.typeShow = false;
    }
  },
  computed:{
    ...mapGetters(['loading', 'uid', 'deviceId', 'token', 'appid', 'uname', 'roleName', 'serverName', 'channelId', 'lang', 'clientPlat', 'sdkVersion', 'apkVersion', 'roleId', 'serverId', 'areaId', 'phoneModel', 'isNewUploadLog', 'uniqueId']),
    ...mapGetters('faq', ['errmsg', 'loadingCate', 'categoryList', 'statusQu', 'faqQuStatus']),
    sure: $vm => {
      return $vm.$t('sure')
    },
    back: $vm => {
      return $vm.$t('return')
    },
  },
  mounted(){
    if(this.appid){
      this.showServerName = this.serverName
      this.showRoleName = this.roleName
      this.getCategoryList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        phoneModel: this.phoneModel,
        languageCode: this.lang
      }))
    }
    this.$watch('appid', val => {
      this.showServerName = this.serverName
      this.showRoleName = this.roleName
      this.getCategoryList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        phoneModel: this.phoneModel,
        languageCode: this.lang
      }))
    })
    this.$watch('loadingCate', (val, oldval) => {
      // console.log(val, oldval)
      if(val === 'loadedCate'){
          this.columns = this.categoryList.faqCategoryList.map(val => {
              if(val.id == this.$route.query.faqCategory){
                this.type = val.title
              }
              if(val.title === this.type){
                  this.typeId = val.id
              }
              return val.title
          });
          console.log(this.columns)
        // console.log(this.categoryList.faqCategoryList)
      }
    })
    this.$watch('statusQu', val => {
      if(val === 'statedQu'){
        if(this.faqQuStatus.questionList.questionMessageTextId){
          // if(this.$route.query.type == '2'){
          try {
            if(this.isNewUploadLog){
              typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.uploadLog('' + this.faqQuStatus.questionList.questionId, '' + this.faqQuStatus.questionList.questionMessageTextId, '' + (new Date().getTime() - 24 * 60 * 60 * 1000), '' + new Date().getTime()) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.uploadLog.postMessage({questionId: '' + this.faqQuStatus.questionList.questionId, questionMessagesId: '' + this.faqQuStatus.questionList.questionMessageTextId, startTime: '', endTime: ''}))
            } else {
              typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.uploadLog('' + this.faqQuStatus.questionList.questionId, '' + this.faqQuStatus.questionList.questionMessageTextId, '') || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.uploadLog.postMessage({questionId: '' + this.faqQuStatus.questionList.questionId, questionMessagesId: '' + this.faqQuStatus.questionList.questionMessageTextId, fileNum: ''}))
            }
          } catch (error) {
            console.log('不支持日志')
          }
          // }
          Toast({
            message: this.$t('uploadSuccess'),
            type: 'success',
            onClose: () => {
              if(this.$route.query.faqCategory){
                this.$router.go(-1)
              } else {
                typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
              }
            }
          })
        } else {
          this.showLoad = false
          this.isDisabled = false
        }
      }
    })
  }
}
</script>
<style lang="scss">
.submit{
    color: #c8c9cc;
    margin: 20px;
    .van-loading{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.3);
    }
    .van-loading__spinner--circular{
      top: 50%
    }
    .van-loading__text{
      position: relative;
      top: 50%;
      color: #E60012
    }
    .submit_select{
        position: relative;
        .van-field__body{
            &::after {
                position: absolute;
                top: 50%;
                right: -4px;
                margin-top: -5px;
                border: 3px solid;
                border-color: transparent transparent #dcdee0 #dcdee0;
                -webkit-transform: rotate(-45deg);
                transform: rotate(-45deg);
                opacity: 0.8;
                content: '';
            }
        }
    }
    .van-field{
        margin-top: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .submit_btn{
        margin-top: 10px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>